import { Component, OnInit } from '@angular/core'
import { ToastrModule, ToastrService } from 'ngx-toastr'
import { ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { MatDialog, MatDialogModule } from '@angular/material/dialog'
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component'
import { DatatableComponent } from '../../../shared/components/master-datatable/master-datatable.component'
import { MasterAddUpdateDialogComponent } from '../../../shared/components/master-add-update-dialog/master-add-update-dialog.component'
import { DeliveryTimeModel } from './deliveryTime.model'
import { DeliveryTimeService } from './deliveryTime.service'
import { MasterDatabaseDisplayModel } from '../../../shared/master-database-display.model'
import { MasterCommonServices } from '../../quotation/master.common.service'

@Component({
  selector: 'app-deliverytime.master',
  standalone: true,
  imports: [
    ToastrModule,
    ReactiveFormsModule,
    CommonModule,
    DatatableComponent,
  ],
  templateUrl: './deliveryTime.master.component.html',
  styleUrl: './deliveryTime.master.component.css',
})
export class DeliveryTimeMasterComponent {
  deliverytimeColumns: MasterDatabaseDisplayModel[] = [
    {
      key: 'deliveryTime',
      displayName: 'Delivery Time Name',
      hiddenDataTable: false,
      hiddenDialog: false,
      type: 'text',
    },
    {
      key: 'addedOn',
      displayName: 'Added Date',
      hiddenDataTable: false,
      hiddenDialog: true,
      type: 'date',
    },
    {
      key: 'id',
      displayName: 'Id',
      hiddenDataTable: true,
      hiddenDialog: true,
      type: 'text',
    },
  ]
  isLoading: boolean = false

  constructor(
    private deliverytimeService: DeliveryTimeService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    public masterCommonService: MasterCommonServices,
  ) {}

  openAddUpdateDeliveryTimeDialog(
    mode: string,
    deliverytime?: DeliveryTimeModel,
  ): void {
    const fields = this.deliverytimeColumns
    const dialogRef = this.dialog.open(MasterAddUpdateDialogComponent, {
      data: { item: deliverytime || {}, mode, fields },
    })

    dialogRef.afterClosed().subscribe((result) => {
      

      if (result) {
        if (mode === 'update') {
          this.updateDeliveryTime(result)
        } else {
          this.addDeliveryTime(result)
        }
      }
    })
  }

  addDeliveryTime(deliverytime: any): void {
    this.deliverytimeService.addDeliveryTime(deliverytime).subscribe({
      next: () => {
        this.toastr.success('Delivery Time Added Successfully!', 'Success')
        this.masterCommonService.getAllDeliveryTimes()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  updateDeliveryTime(deliverytime: any): void {
    this.deliverytimeService.updateDeliveryTime(deliverytime).subscribe({
      next: () => {
        this.toastr.success('Delivery Time Updated Successfully!', 'Success')
        this.masterCommonService.getAllDeliveryTimes()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  deleteDeliveryTime(deliverytime: DeliveryTimeModel): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: 'Are you sure you want to delete this delivery time?' },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        deliverytime.isDeleted = true
        this.deliverytimeService.deleteDeliveryTime(deliverytime).subscribe({
          next: () => {
            this.masterCommonService.deliveryTimesList = this.masterCommonService.deliveryTimesList.filter(
              (p) => p.id !== deliverytime.id,
            )
            this.toastr.success(
              'Delivery Time Deleted Successfully!',
              'Success',
            )
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      }
    })
  }
}
